import { render, staticRenderFns } from "./PopupNativeAppUpdate.vue?vue&type=template&id=c4e99d6a&scoped=true"
import script from "./PopupNativeAppUpdate.vue?vue&type=script&lang=js"
export * from "./PopupNativeAppUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c4e99d6a",
  null
  
)

export default component.exports